import type { CSSProperties, ReactNode } from 'react';
import { formatEuros } from '@/utils/format';

/**
 * Recharts ↔ design-system binding shared by every chart —
 * import these instead of cloning per chart file.
 */

// Legacy palette — assigned `CHART_SERIES_COLORS[index % length]` in
// series-discovery order (data-dependent order kept).
const PRIMARY_COLOR = '#08F7FE';
const SECONDARY_COLOR = '#FE74E2';
const ADDITIONAL_COLORS = [
  '#FFD166',
  '#06D6A0',
  '#EE6C4D',
  '#7209B7',
  '#FF5733',
  '#33FF57',
  '#3357FF',
  '#FF33A8',
  '#A833FF',
  '#33FFA8',
  '#FF8C33',
  '#3388FF',
  '#A8FF33',
  '#FF3333',
];
export const CHART_SERIES_COLORS = [PRIMARY_COLOR, SECONDARY_COLOR, ...ADDITIONAL_COLORS];

const AXIS_FONT_SIZE = 12;

// Deliberate deviation: legacy hardcoded white tick/legend text
// for its dark theme — theme tokens keep both v2 themes readable.
export const AXIS_TICK = { fill: 'hsl(var(--muted-foreground))', fontSize: AXIS_FONT_SIZE } as const;
export const GRID_STROKE = 'hsl(var(--border))';
export const CURSOR_FILL = { fill: 'hsl(var(--muted))' } as const;
export const TOOLTIP_CONTENT_STYLE: CSSProperties = {
  backgroundColor: 'hsl(var(--popover))',
  border: '1px solid hsl(var(--border))',
  borderRadius: '0.5rem',
  color: 'hsl(var(--popover-foreground))',
};
export const TOOLTIP_ITEM_STYLE: CSSProperties = { color: 'hsl(var(--popover-foreground))' };

export type TooltipValue = number | string | Array<number | string>;
export const formatEuroTooltip = (value: TooltipValue): string => formatEuros(Number(value));

export const renderLegendLabel = (value: unknown): ReactNode => <span className="text-sm text-foreground">{String(value)}</span>;
